import { render, staticRenderFns } from "./ShippingChargeTemplate.vue?vue&type=template&id=7cc2f538&"
import script from "./ShippingChargeTemplate.vue?vue&type=script&lang=ts&"
export * from "./ShippingChargeTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports